<div class="section-menu-items py-3">
  <button
    mat-flat-button
    class="item-each"
    [routerLink]="['festival-promo']"
    routerLinkActive="router-link-active"
  >
    <span class="translate text-transform-none"> {{'pages.PromotionCarrierPromotions.Festivals' | translate }}</span>
    <mat-icon class="ms-2">celebration</mat-icon>
  </button>
  <button
  
    mat-flat-button
    class="item-each"
    [routerLink]="['promo-history']"
    routerLinkActive="router-link-active"
  >
    <span class="translate"> {{'pages.Occasionrewards.PromoCodehistory' | translate }} </span>
    <mat-icon class="ms-2">history</mat-icon>
  </button>
</div>
<router-outlet></router-outlet>
